module.exports = __webpack_public_path__ + "img/logotext.2967d517.png";